import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  CanonicalTopicsDataSchema,
  ClusterDomainSchema,
  ClusterSegmentSchema,
  DataResponse,
} from "schema"
import z from "zod"

type Response = DataResponse<z.infer<typeof CanonicalTopicsDataSchema>>

type Props = {
  query: {
    domain: z.infer<typeof ClusterDomainSchema>
    segment?: z.infer<typeof ClusterSegmentSchema>
    withSnapshots?: boolean
  }
  enabled?: boolean
}

export const CanonicalTopicsQuery = ({ query, enabled }: Props) => {
  return queryOptions({
    queryKey: ["canonical-topics", JSON.stringify(query)],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/canonical-topics`, {
        params: query,
      })
      return response.data.data
    },
    enabled,
  })
}
